module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "community-apply-tab-template"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "divided-tabpanels tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "decsList1"
    }
  }, [_c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 개요")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("커뮤니티 명")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    ref: "name",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "maxlength": "30",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("소개글")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.desc),
      expression: "desc",
      modifiers: {
        "trim": true
      }
    }],
    ref: "desc",
    staticClass: "input__textarea input__textarea--thin",
    attrs: {
      "placeholder": "최대 200자까지 입력가능합니다.",
      "rows": "2",
      "maxlength": "200",
      "title": "최대 200자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("대표이미지")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "formcommunityFile01",
      "id": "formcommunityFile01",
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api/file-uploads"
    }
  }, [_c('input', {
    ref: "imgUrl",
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "communityFile01",
      "accept": "image/gif, image/jpeg, image/png",
      "title": "대표이미지 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange('communityFile01')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "guide-text"
  }, [_vm._v("277 * 208 px에 최적화 되어 있습니다.")]), _vm._v(" "), (_vm.imgUrl) ? _c('img', {
    staticClass: "file-uploads-thumb",
    attrs: {
      "src": _vm.imgUrl,
      "alt": "업로드이미지"
    }
  }) : _c('img', {
    staticClass: "file-uploads-thumb",
    attrs: {
      "alt": "업로드이미지",
      "src": "/images/img/communityDefault.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("등록기관")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.org),
      expression: "org",
      modifiers: {
        "trim": true
      }
    }],
    ref: "org",
    staticClass: "input__select",
    attrs: {
      "title": " 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.org = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orgList), function(list) {
    return _c('option', {
      domProps: {
        "value": list.code
      }
    }, [_vm._v(_vm._s(list.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("회원수")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.memberCount),
      expression: "memberCount",
      modifiers: {
        "trim": true
      }
    }],
    ref: "memberCount",
    staticClass: "input__text",
    attrs: {
      "type": "number",
      "placeholder": "숫자로만 입력해주세요. 예) 10명 일경우 10",
      "title": "숫자로만 입력해주세요. 예) 10명 일경우 10"
    },
    domProps: {
      "value": (_vm.memberCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberCount = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("결성시기")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formationYear),
      expression: "formationYear",
      modifiers: {
        "trim": true
      }
    }],
    ref: "formationYear",
    staticClass: "input__text",
    attrs: {
      "type": "number",
      "placeholder": "예) 1990년일 경우 1990",
      "maxlength": "4",
      "title": "예) 1990년일 경우 1990"
    },
    domProps: {
      "value": (_vm.formationYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formationYear = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formationMonth),
      expression: "formationMonth",
      modifiers: {
        "trim": true
      }
    }],
    ref: "formationMonth",
    staticClass: "input__text",
    attrs: {
      "type": "number",
      "placeholder": "예) 1월일 경우 01",
      "maxlength": "2",
      "title": "예) 1월일 경우 01"
    },
    domProps: {
      "value": (_vm.formationMonth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formationMonth = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("모임주기")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-6"
  }, [_c('label', {
    staticClass: "checkbox-inline label__radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.meetingChk),
      expression: "meetingChk",
      modifiers: {
        "trim": true
      }
    }],
    ref: "meetingChk",
    staticClass: "input__checkbox",
    attrs: {
      "type": "radio",
      "value": "fixed",
      "title": "정기 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.meetingChk, "fixed")
    },
    on: {
      "change": function($event) {
        _vm.meetingChk = "fixed"
      }
    }
  }), _vm._v(" 정기\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.meetingPeriod),
      expression: "meetingPeriod",
      modifiers: {
        "trim": true
      }
    }],
    ref: "meetingPeriod",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "예) 주 1회",
      "maxlength": "30",
      "title": "예) 주 1회"
    },
    domProps: {
      "value": (_vm.meetingPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meetingPeriod = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-5"
  }, [_c('label', {
    staticClass: "checkbox-inline label__radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.meetingChk),
      expression: "meetingChk",
      modifiers: {
        "trim": true
      }
    }],
    ref: "meetingChk",
    staticClass: "input__checkbox",
    attrs: {
      "type": "radio",
      "value": "non-fixed",
      "title": "비정기 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.meetingChk, "non-fixed")
    },
    on: {
      "change": function($event) {
        _vm.meetingChk = "non-fixed"
      }
    }
  }), _vm._v(" 비정기\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.meetingPlace),
      expression: "meetingPlace",
      modifiers: {
        "trim": true
      }
    }],
    ref: "meetingPlace",
    staticClass: "input__select",
    attrs: {
      "title": " 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meetingPlace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.address), function(list) {
    return _c('option', [_vm._v(_vm._s(list))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("활동 주제")]), _vm._v(" "), _vm._l((_vm.subject), function(list, idx) {
    return _c('label', {
      staticClass: "radio-inline label__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.selectSubject),
        expression: "selectSubject",
        modifiers: {
          "trim": true
        }
      }],
      ref: "selectSubject",
      refInFor: true,
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions",
        "id": ("inlineRadio" + idx),
        "title": "활동 주제 선택"
      },
      domProps: {
        "value": list.name,
        "checked": _vm._q(_vm.selectSubject, list.name)
      },
      on: {
        "change": function($event) {
          _vm.selectSubject = list.name
        }
      }
    }), _vm._v(" " + _vm._s(list.name) + "\n          ")])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-6"
  }, [_c('label', {
    staticClass: "checkbox-inline label__radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.editagree),
      expression: "editagree",
      modifiers: {
        "trim": true
      }
    }],
    ref: "editagree",
    staticClass: "input__checkbox",
    attrs: {
      "type": "radio",
      "value": "Y",
      "title": "예 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.editagree, "Y")
    },
    on: {
      "change": function($event) {
        _vm.editagree = "Y"
      }
    }
  }), _vm._v(" 예\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-5"
  }, [_c('label', {
    staticClass: "checkbox-inline label__radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.editagree),
      expression: "editagree",
      modifiers: {
        "trim": true
      }
    }],
    ref: "editagree",
    staticClass: "input__checkbox",
    attrs: {
      "type": "radio",
      "value": "N",
      "title": "아니요 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.editagree, "N")
    },
    on: {
      "change": function($event) {
        _vm.editagree = "N"
      }
    }
  }), _vm._v(" 아니요\n            ")])])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goStep2
    }
  }, [_vm._v("다음")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "decsList2"
    }
  }, [_c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 한마디")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3 p-r-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentsWriter),
      expression: "commentsWriter",
      modifiers: {
        "trim": true
      }
    }],
    ref: "commentsWriter",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.commentsWriter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentsWriter = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-33"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentsInput),
      expression: "commentsInput",
      modifiers: {
        "trim": true
      }
    }],
    ref: "commentsInput",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 100자까지 입력가능합니다.",
      "title": "최대 100자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.commentsInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentsInput = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "input-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addComments
    }
  }, [_vm._v("추가")])]), _vm._v(" "), (_vm.comments.length > 0) ? _c('ul', {
    staticClass: "input-added-list"
  }, _vm._l((_vm.comments), function(comment, idx) {
    return _c('li', [_c('div', {
      staticClass: "result-group-with-btn clearfix"
    }, [_c('div', {
      staticClass: "grid-3"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(comment.writer))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-33 border-l l-m-p-10"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(comment.comment))])]), _vm._v(" "), _c('button', {
      staticClass: "input-btn btn--gray",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeComments(idx)
        }
      }
    }, [_vm._v("삭제")])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("배너 등록")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('form', {
    attrs: {
      "name": "formbannerImg",
      "id": "formbannerImg",
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api/file-uploads"
    }
  }, [_c('input', {
    ref: "bannerImg",
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "bannerImg",
      "accept": "image/gif, image/jpeg, image/png",
      "title": "bannerImg 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange('bannerImg')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3 p-r-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.title),
      expression: "title",
      modifiers: {
        "trim": true
      }
    }],
    ref: "title",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.linkUrl),
      expression: "linkUrl",
      modifiers: {
        "trim": true
      }
    }],
    ref: "linkUrl",
    staticClass: "input__text",
    attrs: {
      "type": "url",
      "placeholder": "예) http://www.naver.com / 최대 50자까지 입력가능합니다.",
      "title": "예) http://www.naver.com / 최대 50자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.linkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "input-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addBanner
    }
  }, [_vm._v("추가")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.banners.length > 0) ? _c('ul', {
    staticClass: "input-added-list"
  }, _vm._l((_vm.banners), function(banner, idx) {
    return _c('li', [_c('div', {
      staticClass: "result-group-with-btn clearfix"
    }, [_c('div', {
      staticClass: "grid-3 inner-img"
    }, [(banner.imageUrl) ? _c('img', {
      staticClass: "file-uploads-thumb",
      attrs: {
        "src": banner.imageUrl,
        "alt": "업로드이미지"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "grid-3 border-l l-m-p-10"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(banner.title))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-3"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(banner.linkUrl))])]), _vm._v(" "), _c('button', {
      staticClass: "input-btn btn--gray",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeBanner(idx)
        }
      }
    }, [_vm._v("삭제")])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 연락처")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이메일")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    ref: "email",
    staticClass: "input__text",
    attrs: {
      "type": "email",
      "placeholder": "example@example.com",
      "title": "example@example.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("홈페이지 url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.homepageUrl),
      expression: "homepageUrl",
      modifiers: {
        "trim": true
      }
    }],
    ref: "homepageUrl",
    staticClass: "input__text",
    attrs: {
      "type": "url",
      "placeholder": "http://daum.net",
      "title": "http://daum.net"
    },
    domProps: {
      "value": (_vm.homepageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.homepageUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("sns url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.snsUrl),
      expression: "snsUrl",
      modifiers: {
        "trim": true
      }
    }],
    ref: "snsUrl",
    staticClass: "input__text",
    attrs: {
      "type": "url",
      "placeholder": "http://facebook.com",
      "title": "http://facebook.com"
    },
    domProps: {
      "value": (_vm.snsUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.snsUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.prevStep('1')
      }
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goStep3
    }
  }, [_vm._v("다음")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "decsList3"
    }
  }, [(_vm.operators.length > 0 && !_vm.isModify2) ? [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "community-add-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modifyOperator()
      }
    }
  }, [_vm._v("수정\n          ")])]), _vm._v(" "), _vm._l((_vm.operators), function(operator, idx) {
    return _c('div', {
      staticClass: "lg-label-form-group"
    }, [_c('div', {
      staticClass: "form-box-gray"
    }, [_c('table', [_c('caption', [_vm._v("커뮤니티 회원 상세 정보")]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이름")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.member.name))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("생년월일")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.member.birthdate))])])])]), _c('tr', [_c('td', [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("연락처")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.member.phone1) + "-" + _vm._s(_vm.member.phone2) + "-" + _vm._s(_vm.member.phone3))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이메일")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.member.email))])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("주소")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.member.addr1) + " " + _vm._s(_vm.member.addr2))])])])])])])])
  })] : _vm._e(), _vm._v(" "), (_vm.operators.length > 0 && _vm.isModify2) ? [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "community-add-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateOperator()
      }
    }
  }, [_vm._v("저장\n          ")])]), _vm._v(" "), _vm._l((_vm.operators), function(operator, idx) {
    return _c('div', {
      staticClass: "lg-label-form-group"
    }, [_c('div', {
      staticClass: "form-box-gray"
    }, [_c('table', [_c('caption', [_vm._v("커뮤니티 회원 목록")]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이름")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.name),
        expression: "member.name",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.name",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "",
        "readonly": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "name", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("생년월일")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.birthdate),
        expression: "member.birthdate",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.birthdate",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "",
        "readonly": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.birthdate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "birthdate", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])]), _c('tr', [_c('td', [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("연락처")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.phone1),
        expression: "member.phone1",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.phone1",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "number",
        "maxlength": "3",
        "oninput": "this.value=this.value.slice(0,this.maxLength)",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.phone1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "phone1", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.phone2),
        expression: "member.phone2",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.phone2",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "number",
        "maxlength": "4",
        "oninput": "this.value=this.value.slice(0,this.maxLength)",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.phone2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "phone2", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.phone3),
        expression: "member.phone3",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.phone3",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "number",
        "maxlength": "4",
        "oninput": "this.value=this.value.slice(0,this.maxLength)",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.phone3)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "phone3", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이메일")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.email),
        expression: "member.email",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.email",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "email", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("주소")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.addr1),
        expression: "member.addr1",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.addr1",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.addr1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "addr1", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "inline-readonly-group clearfix"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.member.addr2),
        expression: "member.addr2",
        modifiers: {
          "trim": true
        }
      }],
      ref: "member.addr2",
      refInFor: true,
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "",
        "title": " 입력"
      },
      domProps: {
        "value": (_vm.member.addr2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.member, "addr2", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])])])])
  })] : _vm._e(), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.prevStep('2')
      }
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goStep4
    }
  }, [_vm._v("다음")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "decsList4"
    }
  }, [_c('div', {
    staticClass: "lg-label-form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('label', {
    staticClass: "checkbox-inline progress-label__agree-ckeck"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.isPrivacyAgree),
      expression: "isPrivacyAgree",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "privacyAgree",
      "value": "privacyAgree",
      "title": "개인정보 수집 이용 동의 확인 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPrivacyAgree) ? _vm._i(_vm.isPrivacyAgree, "privacyAgree") > -1 : (_vm.isPrivacyAgree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPrivacyAgree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "privacyAgree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPrivacyAgree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPrivacyAgree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPrivacyAgree = $$c
        }
      }
    }
  }), _vm._v(" 확인하였습니다.\n          ")])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.prevStep('3')
      }
    }
  }, [_vm._v("이전 ")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.communityApply
    }
  }, [_vm._v("신청하기")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "divided-tabs tab-count--5 clearfix",
    attrs: {
      "role": "tablist",
      "id": "buttons-tab"
    }
  }, [_c('li', {
    staticClass: "divided-tab active",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "presentation",
      "id": "step1"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList1",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab"
    }
  }, [_vm._v("\n        커뮤니티 개요"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "presentation",
      "id": "step2"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList2",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab"
    }
  }, [_vm._v("\n        커뮤니티 정보"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "presentation",
      "id": "step3"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList4",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab"
    }
  }, [_vm._v("\n        커뮤니티 운영자"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "presentation",
      "id": "step4"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList5",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab"
    }
  }, [_vm._v("\n        커뮤니티 사업안내"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("주요 모임  "), _c('br'), _vm._v("또는 활동 장소")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("※ 관리자가 커뮤니티 소식 컨텐츠를 수정할 수 있다는 것에 대해 동의 하십니까?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 총무 김무자")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-33"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 지치지 않는 열정의 프로펠러")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 총무 김무자")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 꽃동네 봉사활동")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("http://www.naver.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helper-text xs-text"
  }, [_vm._v("*확장자 jpg, jpeg, png, gif"), _c('br'), _vm._v(" 파일만\u2029올려주세요.(2mb 이하)"), _c('br'), _vm._v("1130*204px")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("내용")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("50+세대가 동료와 함께 기획한 프로젝트를 실행하도록 활동비 등을 지원합니다. 자신의 경험과 재능을 동료와 나누세요. 서부캠퍼스 교육과정 수강을 계기로 모였거나 관심사를 공유하는 50+세대 커뮤니티라면 신청 가능합니다.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("대상")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  캠퍼스 프로그램 참여 후 동기들과 활동을 이어가기 위해 결성한 커뮤니티")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  50+세대 생애 설계, 신문화 확산 관련 활동을 하고 있거나 계획 중인 커뮤니티")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  지역사회, 세대통합 등 공익을 위한 활동을 하고 있거나 계획 중인 커뮤니티")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("01. 최소 3명 이상의 50+세대로 구성된 모임이어야 합니다.")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("02. 대표자는 만 50 ~ 64세의 서울시민이거나 사업장 주소가 서울시여야 합니다.")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("03. 국적 등 기타 자격 관련 사항은 별도 문의 바랍니다.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("지원활동")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("50+세대의 일, 학습, 문화생활, 사회공헌 관련 활동")]), _vm._v(" "), _c('div', {
    staticClass: "progress-etc-box"
  }, [_c('h5', {
    staticClass: "progress-etc-box__title"
  }, [_vm._v("예시)")]), _vm._v(" "), _c('ul', {
    staticClass: "progress-etc-box__ul"
  }, [_c('li', [_vm._v("· 창업·창직, 경력개발, 사회적경제, 공익단체설립 등 일 관련 연구 및 실행 활동")]), _vm._v(" "), _c('li', [_vm._v("· 신기술, 사회이론, 인문학, 역사, 기타 주제 강의, 세미나, 포럼 등 학습 활동")]), _vm._v(" "), _c('li', [_vm._v("· 예술, 문학, 음악, 미술, 영상 등의 감상 및 창작 관련 문화 활동")]), _vm._v(" "), _c('li', [_vm._v("· 지역사회, 세대통합, 취약계층, 공익 등을 위한 사회공헌 활동")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("신청방법")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  홈페이지 접수")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  제출 서류 : 참가신청서 (홈페이지에서 양식 다운로드 후 작성)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("선정절차")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/images/applystep.png",
      "alt": "단계설명이미지"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("선정기준")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  활동 계획 : 사업 취지와의 적합성, 활동 목적의 현실성, 계획의 구체성")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("•  예산 편성 : 예산안의 적합성과 구체성, 활동비 지출 관리 역량")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("01. 캠퍼스 프로그램 참여 후 관련 활동을 계획하는 커뮤니티를 우대합니다.")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("02. 개방적인 성격의 커뮤니티로 캠퍼스에서 동료를 찾는 커뮤니티를 우대합니다.")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("03. 상담 과정에서 대표와 구성원의 활동 의지, 의사소통 정도를 중점적으로 확인합니다.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59de60c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/CommunityTab.vue
// module id = 1410
// module chunks = 6